import { useNavigate } from "react-router-dom";
import { logout, useAuthStore } from "@safers/auth";
import { clearLastVisit } from "@/lib/lastVisit";
import { LOGIN_PATH } from "@/routes/paths";

/**
 * 로그아웃 한 벌. 네 곳에서 같은 순서를 되풀이하고 있었는데, 그중 하나만 빠뜨려도
 * 다음 로그인이 앞 계정의 화면으로 착지한다.
 *
 * 서버 호출이 실패해도 클라이언트 정리는 끝까지 한다.
 */
export function useSignOut(): () => Promise<void> {
  const navigate = useNavigate();

  return async () => {
    const username = useAuthStore.getState().user?.username ?? null;
    await logout().catch(() => {});
    clearLastVisit(username);
    useAuthStore.getState().reset();
    navigate(LOGIN_PATH, { replace: true });
  };
}
